module.exports = __webpack_public_path__ + "static/media/brand.feb657d7.png";